/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import produce from 'immer';
import ExchangeOrders from '.';
import { EditedCreateExchangeOrder } from './exchange-orders-models';

const initializeState: ExchangeOrders.model.ExchangeOrdersReducer = {
  editedExchangeOrder: undefined,
  shouldValidate: false,
  validDates: [],
  investableAccountBalance: undefined,
  investableSecurityAmount: undefined,
};

export default (
  state = initializeState,
  action: { type: string; payload: ExchangeOrders.model.ExchangeOrdersActionsPayload },
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ExchangeOrders.actionTypes.SET_EDITED_EXCHANGE_ORDER:
        draft.editedExchangeOrder = action.payload as EditedCreateExchangeOrder | undefined;
        return draft;
      case ExchangeOrders.actionTypes.SET_SHOULD_VALIDATE:
        draft.shouldValidate = action.payload as boolean;
        return draft;
      case ExchangeOrders.actionTypes.SET_VALID_DATES:
        draft.validDates = action.payload as string[];
        return draft;
      case ExchangeOrders.actionTypes.SET_INVESTABLE_ACCOUNT_BALANCE:
        draft.investableAccountBalance = action.payload as number | undefined;
        return draft;
      case ExchangeOrders.actionTypes.SET_INVESTABLE_SECURITY_AMOUNT:
        draft.investableSecurityAmount = action.payload as number | undefined;
        return draft;
      default:
    }
  });
